import React from 'react';

import {RouteData} from '../types';
import {
  INFERENCE_COLLECTION_PATH,
  INFERENCE_COMPARE_PATH,
  INFERENCE_MODEL_PATH,
} from './inferencePaths';

export const INFERENCE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'InferenceModel',
    },
    isPrivateRoute: false,
    path: INFERENCE_MODEL_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Inference',
    },
    isPrivateRoute: false,
    path: INFERENCE_COLLECTION_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
  {
    additionalProps: {
      allowIframes: false,
      routeName: 'Inference Compare',
    },
    isPrivateRoute: false,
    path: INFERENCE_COMPARE_PATH,
    RouteComponent: React.lazy(
      () => import('../../pages/HomePage/HomePageWithData')
    ),
  },
];
